<div class="bg-black h-screen w-screen text-white flex justify-center">
    @if (!loading && !error) {
        <div class="container h-full">
            <div class="flex flex-col h-full items-center justify-center">
                <div class="flex flex-col gap-10 w-full">
                    <div class="flex gap-10 border-b border-white pb-10 2xl:pb-20">
                        <img [src]="sampleView?.imageUrl || '/assets/mb-logo-large.png'" alt="Sample Image"
                             class="w-52 h-52 object-cover"/>
                        <div class="flex flex-col gap-3">
                            <h1 class="xl:text-5xl">{{ sampleView?.name }}</h1>
                            <p class="text-xl text-light-gray">{{ sampleView?.categoryName }}</p>
                        </div>
                    </div>
                    <div>
                        <p class="text-2xl 2xl:text-3xl">Vehicles</p>
                        <!-- Show grid if vehicles exist -->
                        @if (paginatedVehicles && paginatedVehicles.length > 0) {
                            <div>
                                <div [@pageChangeAnimation]="currentPage"
                                     class="grid grid-cols-5 grid-rows-2 gap-4 mt-5">
                                    @for (vehicle of paginatedVehicles; track vehicle) {
                                        <div class="vehicle-model-box">
                                            <img [src]="vehicle.imageUrl || 'assets/images/vehicle_fallback.png'"
                                                 alt="Vehicle Model"
                                                 class="w-full h-auto object-cover">
                                            <p class="text-center text-lg mt-2 mb-4">{{ vehicle.vehicleName }}</p>
                                        </div>
                                    }
                                </div>
                                <!-- Pagination Dots -->
                                @if (totalPagesArray.length > 1) {
                                    <div class="flex justify-center mt-10">
                                        @for (page of totalPagesArray; track page; let i = $index) {
                                            <div
                                                    [ngClass]="{'bg-[#008DFC]': i === currentPage, 'bg-[#767676]': i !== currentPage}"
                                                    class="w-[12px] h-[12px] rounded-full mx-1">
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="flex justify-center items-center mt-10">
                                <p class="text-xl text-gray-500">No vehicle models found for this sample</p>
                            </div>
                        }
                        <!-- Fallback template -->
                    </div>
                </div>
            </div>
    </div>
    }
    @if (loading && !error) {
        <div class="flex justify-center items-center h-full">
            <p-progress-spinner [style]="{ width: '50px', height: '50px' }" animationDuration=".5s" fill="transparent"
                                strokeWidth="2"/>
    </div>
    }
    @if (error) {
        <div class="flex justify-center items-center h-full">
            <div class="flex flex-col items-center gap-10">
                <img alt="MB Logo" class="w-96 h-96 object-cover" src="/assets/mb-logo-large.png"/>
                <p class="text-center">An error occurred please try again later.</p>
            </div>
    </div>
    }

</div>
